<template>
    <div class="sampleSelectControl">
        <div>
            <el-autocomplete
                    class="inline"
                    v-model="name"
                    :fetch-suggestions="searchQuery"
                    placeholder="Please Input"
                    :trigger-on-focus="focusItem"
                    :highlight-first-item="lightItem"
                    :clearable="clearItem">
            </el-autocomplete>
        </div>
        <br>
        <div>
            <span>포커스시 리스트 출력 여부 : </span>
            <el-select v-model="focusItem">
                <el-option
                        v-for="item in focus"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <br>
        <div>
            <span>첫번째 항목 하이라이트 여부 : </span>
            <el-select v-model="lightItem">
                <el-option
                        v-for="item in light"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <br>
        <div>
            <span>내용 삭제 버튼 : </span>
            <el-select v-model="clearItem">
                <el-option
                        v-for="item in clear"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div>
            <h1>업체</h1>
            <ACustomerSelector v-model="customer_name" @select="handleSelectCustomer"/>

            <h1>품목</h1>
            <AProductSelector size="mini"
                              :value="estimation.product_name"
                              @select="handleSelectProduct"/>

            <h1>품목 Option & Amount & Cost </h1>
            <AProductAmountInput size="mini"
                                 placeholder="수량을 입력하세요"
                                 :product_id="estimation.product_id"
                                 :value="estimation.amount"
                                 :change="changeAmount"/>

            <AProductCost size="mini"
                          placeholder="단가를 입력하세요"
                          :customer_id="customer_id"
                          :product_id="estimation.product_id"
                          :value="estimation.cost"
                          @change="changeCost"/>
        </div>
    </div>
</template>
<script>

    var boolean = [{value: true, label: "true"}, {value: false, label: "false"}]
    export default {
        name: 'sampleSelectControl',
        data() {
            return {
                focusItem: true,
                lightItem: true,
                clearItem: true,
                focus: boolean,
                light: boolean,
                clear: boolean,
                name: '',
                links: [],
                customer_id: 9,
                customer_name: 'AD미래자동문',
                estimation: {
                    "amount": 3.0,
                    "cost": 33000,
                    "desc": null,
                    "estimation_id": 74,
                    "fix_amount": 0.0,
                    "id": 47,
                    "product_id": 2,
                    "product_name": "못",                    
                    "size": null,
                    "seq": 1,
                    "supply_price": 99000
                }
            }
        },
        methods: {

            searchQuery(queryString, cb) {
                var links = this.links;
                var results = queryString ? links.filter(this.filterCreate(queryString)) : links;
                cb(results);
            },
            filterCreate(queryString) {
                return (link) => {
                    return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            loadAll() {
                return [
                    {"value": "vue", "link": "https://github.com/vuejs/vue"},
                    {"value": "element", "link": "https://github.com/ElemeFE/element"},
                    {"value": "cooking", "link": "https://github.com/ElemeFE/cooking"},
                    {"value": "mint-ui", "link": "https://github.com/ElemeFE/mint-ui"},
                    {"value": "vuex", "link": "https://github.com/vuejs/vuex"},
                    {"value": "vue-router", "link": "https://github.com/vuejs/vue-router"},
                    {"value": "babel", "link": "https://github.com/babel/babel"}
                ];
            },
            handleSelect(item) {
                console.error(item);
            },
            handleSelectCustomer(c) {
                if (typeof (c) === 'string') {
                    this.customer_id = null;
                    this.customer_name = c;
                } else {
                    this.customer_id = c.id;
                    this.customer_name = c.name;
                    // this.data.location = c.location;
                    // this.data.tel = c.tel || c.tel2 || c.owner_tel;
                    // this.data.addr = c.addr;
                }
            },
            handleSelectProduct(p) {

                console.error(p)
                // const trade = this.items[index];
                if (typeof (p) === 'string') {
                    // trade.product_name = '';
                    // trade.product_id = null;
                    // trade.cost = '';
                    this.estimation.product_id = null

                } else {

                    this.estimation.product_id = p.id

                    // trade.product_name = p.name;
                    // trade.product_id = p.id;
                    // trade.cost = p.cost;
                    // this.$nextTick(() => {
                    //     this.$refs.options[index].focus();
                    // });
                }
                // if (trade.cost === p.cost) { return; }
                // this.calculate(index);

                this.estimation.size = ''
                this.estimation.amount = null
                this.estimation.cost = null
            },
            changeAmount(data) {
                this.estimation.amount = data;
            },
            changeCost(data/*, originProductCost*/) {
                this.estimation.cost = data;
            }
        },
        mounted() {
            this.links = this.loadAll();
        }
    };
</script>
